export enum HealthStates {
  Healthy = 1,
  Warning = 2,
  Error = 3
}

export enum MetricWarningOrders {
  CheckUp = 1,
  CheckDown = 2
}

export enum MetricTypes {
  Maintenance = 1,
  MeterBased = 2,
  Audit = 3,
  Checklist = 4
}
